import { Reveal, Overline } from "./Reveal";

export const Host = () => (
  <section id="host" data-testid="host-section" className="py-24 md:py-40">
    <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <Overline>Meet the host</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <blockquote className="font-serif font-light text-textMain text-3xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight mt-10">
          "I don't believe in simply providing accommodation. I believe in creating the sort of stay I'd hope to receive myself."
        </blockquote>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="font-sans text-textMuted leading-relaxed mt-10 max-w-xl mx-auto">
          Every detail has been carefully considered, every guest is genuinely welcomed, and my aim is simple: for you to arrive as guests and leave feeling like friends. More than just a place to stay — an experience you'll remember long after you've returned home.
        </p>
      </Reveal>
      <Reveal delay={0.28}>
        <div className="mt-12 flex flex-col items-center gap-3">
          <span className="h-px w-16 bg-line" />
          <p className="font-serif italic text-3xl text-primary" data-testid="host-signature">Jo</p>
          <span className="font-mono text-[10px] uppercase tracking-ultra text-textMuted">Your host</span>
        </div>
      </Reveal>
    </div>
  </section>
);
